<div
	class="modal fade"
	id="modal-spinner"
	data-backdrop="static"
	data-keyboard="false"
	tabindex="-1"
	role="dialog"
	aria-labelledby="exampleModalCenterTitle"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-centered modal-sm" role="document">
		<div class="modal-content">
			<div class="modal-body">
				<div class="loader"></div>
				<h3 class="text-center">{{ text }}</h3>
			</div>
		</div>
	</div>
</div>
